<template>
    <b-table-simple v-if="classes" hover responsive foot-clone>
      <b-thead>
        <b-tr>
          <b-th>Klassenstufe</b-th>
          <b-th class="w-25">Anzahl Schüler*innen</b-th>
          <b-th>Teilnahmeform</b-th>
          <b-th colspan=2></b-th>
        </b-tr>
      </b-thead>

      <b-tbody>
        <b-tr v-for="row in classes.models" :key="row.ageGroup">
          <b-td class="pl-4">{{ row.ageGroup }}</b-td>
          <b-td class="pl-4">{{ row.count }}</b-td>
          <b-td class="pl-4">{{ row.type === 'paper' ? 'Papier' : 'Online' }}</b-td>
          <b-td colspan=2>
            <b-button v-if="!disabled" variant="danger" size="sm" class="float-right" v-on:click="removeClass(row.ageGroup)">
              <font-awesome-icon icon="trash-alt" />
            </b-button>
          </b-td>
        </b-tr>
      </b-tbody>

      <b-tfoot v-if="editable">
        <!------ Add class form in table footer ------->
        <b-tr>
          <b-td>
            <b-form-select name="ageGroup" v-model="form.ageGroup" :options="ageOptions" />
          </b-td>

          <b-td>
            <b-form-input name="count" v-model="form.count" type="number" min=1 />
          </b-td>

          <b-td>
            <b-button variant="primary" v-on:click="addClass">{{ addButtonTitle }}</b-button>
          </b-td>

          <b-td class="text-right">
            <b-button v-if="showSaveButton" v-on:click="save" variant="primary">
              Speichern
            </b-button>
          </b-td>
        </b-tr>
        <!------ End form in table footer ------->
      </b-tfoot>

    </b-table-simple>
</template>

<script>
import {RegisteredClass} from '@/models'

export default {
  name: 'ClassList',
  props: ['classes', 'withSave', 'disabled'],

  data: function () {
    return {
      form: {
        ageGroup: 3,
        count: 10,
        type: 'online'
      },
      ageOptions: [3, 4, 5, 6, 7, 8],
      table: {
        footClone: false,
        fields: [
          {key: 'ageGroup', label: 'Klassenstufe'},
          {key: 'count', label: 'Anzahl Schüler*innen'},
          {key: 'type', label: 'Teilnahmeform'},
          {key: 'buttons', label: ''}
        ]
      }
    }
  },

  computed: {
    editable: function () {
      return !('disabled' in this.$props) || !this.disabled
    },

    showSaveButton: function () {
      return 'withSave' in this.$props && this.withSave !== false && this.withSave !== undefined
    },

    addButtonTitle: function () {
      return this.classes.has({ageGroup: this.form.ageGroup})
        ? 'Klasse aktualisieren'
        : 'Klasse hinzufügen'
    }
  },

  methods: {
    addClass () {
      const ageGroup = parseInt(this.form.ageGroup)
      const count = parseInt(this.form.count)
      const existing = this.classes.find({ageGroup: ageGroup})

      if (existing !== undefined) {
        existing.count = count
        existing.type = this.form.type

        return
      }

      this.classes.add(new RegisteredClass({
        ageGroup: ageGroup,
        count: count,
        type: 'online'
      }))

      this.classes.sort('ageGroup')
    },

    removeClass (ageGroup) {
      this.classes.remove({ageGroup: ageGroup})
    },

    save () {
      this.$emit('save')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/registration/ClassList.vue